import { GET_ALL_REGEX, GET_SPECIFIC_REGEX } from './mutation-types'

import regexHttpService from '../_services/regexHttpService'

export default {
  listarTodasRegex: async ({ commit }) => {
    try {
      const response = await regexHttpService.getAllRegex()
      commit(GET_ALL_REGEX, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarUmaRegex: async ({ commit }, _id) => {
    try {
      const response = await regexHttpService.getOneRegex(_id)
      commit(GET_SPECIFIC_REGEX, response.data)
    } catch (e) {
      console.log(e)
    }
  },
}
